import type { Entity, QueriesObject, QueryResults, System } from '../../odie';
import { SpiderClimbEffect } from '../actions/effects/SpiderClimbEffect';

import { BlockComponent } from '../components/BlockComponent';
import { PhaseComponent } from '../components/PhaseComponent';
import { SpiderBlockComponent } from '../components/SpiderBlockComponent';
import { PhaseId } from '../defs/types';
import { BlockEntity, SpiderBlockEntity } from '../entities/BlockEntity';
import type { GameScene } from '../GameScene';
import { blockIsBinded, blockIsFrozen } from '../util/blockTools';

export class SpiderBlockSystem implements System {
  public static readonly NAME = 'blockSpider';
  public static Queries: QueriesObject = {
    blockSpider: {
      components: [BlockComponent, SpiderBlockComponent],
    },
    phase: {
      components: [PhaseComponent],
      modified: true,
    },
  };

  public scene!: GameScene;
  public queries!: QueryResults;

  public modifiedQuery(
    entity: Entity,
    component: PhaseComponent,
    properties: { phase: PhaseId },
  ) {
    const { phase, moved, round } = component;

    if (properties.phase && phase === 'input' && round > 0) {
      // Only if there has been a move made in the previous phase cycle, trigger spider climb check
      if (moved) this._activateSpiders();
      // Reset moved flag for the current phase cycle
      this._resetSpiderMovedDown();
    }
  }

  private async _activateSpiders() {
    const phase = this.scene.sessionEntity.c.phase;

    // don't activate any spiders which are frozen or binded, reverse to emulate query forEach
    const spiderEntities: SpiderBlockEntity[] =
      this.queries.blockSpider.entities
        .filter(
          (entity) =>
            !blockIsFrozen(this.scene, entity as BlockEntity) &&
            !blockIsBinded(this.scene, entity as BlockEntity),
        )
        .reverse() as SpiderBlockEntity[];

    if (!spiderEntities.length) {
      return;
    }

    phase.activePush();

    // Wait for all spiders processes to complete before popping activations
    await new SpiderClimbEffect(this.scene, {
      spiderEntities,
    }).execute();

    await phase.activePop();
  }

  private async _resetSpiderMovedDown() {
    this.queries.blockSpider.forEach(
      (entity: SpiderBlockEntity) => (entity.c.blockSpider.movedDown = false),
    );
  }
}
